
          import "Checkbox.styles_ut2g1l.linaria.css";
          import { styled } from "@linaria/react";
import { typeStyle, focusStyle } from "@carvana/showroom-css-theme";
export const CheckboxWrapper = /*#__PURE__*/styled("label")({
  name: "CheckboxWrapper",
  class: "c10pta7s"
});
export const HiddenCheckbox = /*#__PURE__*/styled("input")({
  name: "HiddenCheckbox",
  class: "hopfmpb"
});
          